import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useEventsStore} from "../../store/events.store";

export const useEvent = () => {
    const setEvent = useEventsStore((state) => state.setEvent);

    return useMutation(PartnerApi.event, {
        onSuccess: (data) => {
            setEvent(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};